import React from 'react';
import { useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import Logo from '../components/shared/Logo';
import AppTitle from "../components/shared/AppTitle";

export default function Splash(props) {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;


    useEffect(() => {
        window.localStorage.setItem('logo', config.logo)
        const params = new URLSearchParams(window.location.search);

        const vendorIdFromUrl = params.get('vendor');

        const vendorIdToStore = vendorIdFromUrl || '1';

        localStorage.setItem('_vid', vendorIdToStore);


    }, []);

    useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        const timeoutId = setTimeout(() => {
            if(token) {
                if(window.localStorage.getItem("needRegistration") > 0){
                    navigate('/register');
                    return;
                }

                navigate('/home');
            }
            else {
                if(config.service_app_settings.need_login > 0 ) {
                    navigate('/login');
                    return;
                }
                navigate('/home');
            }
        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (

            <section className="container-fluid mobile-size-option splash-screen" >
                <div className="row ">
                    <div className="col-12 text-center ">
                        <Logo size={100} square />
                    </div>
                    <div className="col-12 text-center mt-3 splash-text fw-bold">
                        <AppTitle as="h2" className="text-primary-color fw-bold" />
                    </div>
            {/*        <h6 className="col-12 text-center mt-4  text-small-3 fw-bold opacity-50">
                        <AppTitle as="span" className="text-secondary-color" field='slogan' />
                    </h6>*/}
                    <div className="col-12 text-center fixed-bottom mb-5">
                        <div className="spinner-grow text-muted mb-3" role="status">

                        </div>
                  {/*      <div className='text-muted opacity-75 text-small-2'>
                            {config.today}
                        </div>*/}
                    </div>
                </div>
            </section>

    );
}
